var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.btnFlag)?_c('div',{staticClass:"btnbg",on:{"click":_vm.backTop}},[_c('img',{attrs:{"src":require("../assets/images/backup.png"),"alt":""}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }